import React from "react"
import tw from "twin.macro"
import Modal from "@components/Modal"

import CloseButton from "@images/shared/icon_close-button.inline.svg"

const ModalVideo = ({ triggerContent, triggerStyles, destinationUrl, screenshotMode, targetModal, tabIndex, modalPanelStyles, dialogPanelStyles, additionalAction, children }) => {
  const ModalContent = ({ closemodal }) => {
    return (
      <div
        data-gtm="modal-video"
        tw="w-full lg:(w-screen max-w-5xl)"
      >
        <button
          css={[tw`block ml-auto`, screenshotMode && tw`outline-none`]}
          onClick={() => {
            closemodal();
            const heroVideo = document.querySelector('[data-id="hero-video"] video');
            if (heroVideo) {
              heroVideo.play();
            }
            const modalVideo = document.querySelector('[data-id="video-in-modal"] video');
            if (modalVideo) {
              modalVideo.pause();
              modalVideo.currentTime = 0;
            }
          }}
          aria-label="close modal"
        >
          <CloseButton />
        </button>
        {children}
      </div>
    )
  }

  return (
    <Modal
      targetModal={targetModal}
      destinationUrl={destinationUrl}
      triggerContent={triggerContent}
      triggerStyles={triggerStyles}
      modalGtmName="trigger-video-modal"
      modalTitle="Video modal"
      tabIndex={tabIndex}
      modalPanelStyles={modalPanelStyles}
      dialogPanelStyles={dialogPanelStyles}
      additionalAction={additionalAction}
    >
      <ModalContent />
    </Modal>
  )
}

export default ModalVideo
